import {
  DotLoading,
  List,
  Modal,
  Popup,
  Tag,
  Toast,
  Tabs,
  Dialog,
} from "antd-mobile";
import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { Button, Col, Form, Row, Card } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import PsContext from "../../context";
import { currentSemesterStartAndEndDate } from "../../models/academicYears";
import { getFileLiveUrl } from "../../utils";
import ReactFileReader from "react-file-reader";

import {
  momentDate,
  timeTableDayFromNumber,
  upperCase,
  jsonToQuery,
  MOB_ICONS,
  groupByMultiple,
} from "../../utils";
import { ServiceUrl } from "../../utils/serviceUrl";
import { FloatButton, Avatar, Space, Spin } from "antd";
import $ from "jquery";
import Header from "../header";
import LeaveSubstitute from "./leaveSubstitute";
import LeaveSubstituteEdit from "./leaveSubstituteEdit";
import LeaveSubstituteHODEdit from "./leaveSubstituteHODEdit";
const MyLeaveList2 = (props) => {
  const context = useContext(PsContext);
  const [loader, setLoader] = useState(false);
  const [showView, setShowView] = useState(false);
  const [dataList, setDataList] = useState([]);
  const [employeeLeaves, setEmployeeLeaves] = useState([]);
  const [substituteLeaves, setSubstituteLeaves] = useState([]);
  const [substituteStatus, setSubstituteStatus] = useState([]);
  const [viewRequest, setViewRequest] = useState([]);
  const [dataView, setDataView] = useState([]);
  const [showList, setShowList] = useState(true);
  const [leaveTypes, setLeaveTypes] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [showListView, setShowListView] = useState(false);
  const [rolesAccess, setRolesAccess] = useState(false);
  const [totalCount, setTotalCount] = useState("");
  const [leaveTaken, setLeaveTaken] = useState(0);
  const [leaveCount, setLeaveCount] = useState([]);
  const [activeTab, setActiveTab] = useState("myleave");
  const [pendingCount, setPendingCount] = useState(0);
  const [showSubstitute, setShowSubstitute] = useState(false);
  const [showSubstituteEdit, setShowSubstituteEdit] = useState(false);
  const [showSubstituteHODEdit, setShowSubstituteHODEdit] = useState(false);
  const [substituteEdit, setSubstituteEdit] = useState([]);
  const [leaveDate, setLeaveDate] = useState("");
  const [dayOrder, setDayOrder] = useState("");
  const [empID, setEmpId] = useState("");
  const [staffDetails, setStaffDetails] = useState([]);
  const [holidays, setHolidays] = useState([]);
  const [selectedLeaves, setSelectedLeaves] = useState([]);
  const [selectedFile, setSelectedFile] = useState("");
  const [oldFile, setOldFile] = useState("");
  const [day, setDay] = useState();
  const [leaveTakenCount, setTakenLeaveCount] = useState(0);
  const [leaveId, setLeaveID] = useState(0);
  const [leaveEmpId, setEmpLeaveID] = useState(0);
  const [leaveType, setLeaveType] = useState(0);
  const [imageError, setImageError] = useState(false);

  const [fromDate, setFromDate] = useState(
    momentDate(new Date(), "YYYY-MM-DD")
  );
  const [toDate, setToDate] = useState(momentDate(new Date(), "YYYY-MM-DD"));
  const [tableParams, setTableParams] = useState({
    pagination: {
      current: 1,
      pageSize: 50,
    },
    total: 0,
  });

  useEffect(() => {
    axios.post(ServiceUrl.MOB.EMP_HOLIDAY_LIST).then((res) => {
      if (res["data"].status == "1") {
        setHolidays(res["data"].data);
      } else {
        Toast.show({ content: res["data"].message || "Error" });
      }
      setLoader(false);
    });
  }, []);

  useEffect(() => {
    getLeaveTypes();
    console.log(context.settingValue("od_leave_attachment"))
    if (!loader) getReport();
  }, [JSON.stringify(tableParams.pagination)]);

  const getRandomuserParams = (params) => ({
    limit: params.pagination?.pageSize,
    page: params.pagination?.current,
    name: params.pagination?.name,
    from_date: params.pagination?.from_date,
    to_date: params.pagination?.to_date,
    // academic_department: params.pagination?.academic_department,
    //...params,
  });

  const getReport = () => {
    setLoader(true);
    setDataList([]);
    setDataView([]);
    const form = new FormData();
    form.append("staff_id", context.user.id);
    form.append("role_id", context.user.emp_role_id);
    form.append("academic_department", context.user.emp_academic_department);
    axios
      .post(
        ServiceUrl.MOB.EMP_LEAVE_LIST +
        "?" +
        jsonToQuery(getRandomuserParams(tableParams)),
        form
      )
      .then((res) => {
        if (res["data"].status == "1") {
          setDataList(res["data"].data);
          setDataView(res["data"].data);
          setTableParams({
            ...tableParams,
            pagination: {
              ...tableParams.pagination,
              total: res["data"].count,
              // 200 is mock data, you should read it from server
              // total: data.totalCount,
            },
          });

          setEmployeeLeaves(res["data"].employee_leaves);

          setSubstituteLeaves(res["data"].substitude_leaves);
          setSubstituteStatus(res["data"].substitude_approval);

          if (res["data"].rolesaccess > 0) setRolesAccess(true);

          setTotalCount(res["data"].totalapprovalcount);
        } else {
          Toast.show({ content: res["data"].message || "Error" });
        }
        setLoader(false);
      });
  };

  const onLeaveChange = (e) => {
    setPendingCount(0);
    let m = leaveTypes.filter((obj) => obj.leave_type == e);
    getLeaveCount(context.user.id, m[0].id);
  };

  const getLeaveCount = (e, leaveid) => {
    axios
      .get(
        ServiceUrl.MOB.EMPLOYEES_LEAVE_PERMISSION +
        "?status=1&type=leave&emp_id=" +
        e +
        "&leaveid=" +
        leaveid +
        "&from_date=" +
        fromDate
      )
      .then((res) => {
        if (res["data"].status == "1") {
          setLeaveCount(res["data"].allowedleaves);
          if (fromDate && toDate)
            calculateDays(toDate, res["data"].allowedleaves);
        } else {
          //toast.error(res["data"].message || "Error");
        }
        setLoader(false);
      });
  };



  const fileReaderChange = (file) => {
    var types = [
      "image/png",
      "image/jpeg",
      "image/JPEG",
      "image/jpg",
      "image/PNG",
      "image/JPG",
    ];
    if (!types.includes(file.fileList[0].type)) {
      alert("Please select an Image with file extension .jpg or .png", "error");
      return;
    }

    if (file.fileList[0].size < 10000) {
      alert("File size must greater than 10 kb", "error");
      return;
    }

    if (file.fileList[0].size > 300000) {
      alert("File size must less than 300 kb", "error");
      return;
    }

    setSelectedFile(file.base64);
    setImageError(false);
  };


  const getLeaveTypes = () => {
    const form = new FormData();
    form.append("emp_id", context.user.id);
    form.append("role_id", context.user.emp_role_id);
    axios.post(ServiceUrl.MOB.EMP_LEAVE_TYPES_LIST, form).then((res) => {
      if (res["data"].status == "1") {
        setLeaveTypes(res["data"].data);
      } else {
        Toast.show({ content: res["data"].message || "Error" });
      }
      setLoader(false);
    });
  };
  const jointDate = new Date(context.user.emp_joining_date);
  const calculateExperience = () => {
    const today = new Date();
    let experienceYears = today.getFullYear() - jointDate.getFullYear();

    // Check if the current date is before the joint date in the current year
    if (
      today.getMonth() < jointDate.getMonth() ||
      (today.getMonth() === jointDate.getMonth() &&
        today.getDate() < jointDate.getDate())
    ) {
      experienceYears--;
    }

    return experienceYears;
  };

  // console.log(showView.name);
  const handleView = (item) => {
    setShowView(item);

    substituteStatus.filter;
    let res = substituteStatus.filter(
      (obj) =>
        obj.emp_leave_id == item.id && obj.leave_request_emp_id == item.emp_id
    );
    let m = groupByMultiple(res, function (obj) {
      return [obj.leave_request_date];
    });

    setViewRequest(m);
  };

  const handleButtonClick = (item) => {
    substituteStatus.filter;
    let res = substituteStatus.filter(
      (obj) =>
        obj.emp_leave_id == item.id && obj.leave_request_emp_id == item.emp_id
    );

    const allActive = res.every((record) => record.substitute_status === "1");

    if (allActive) {
      const form = new FormData();
      form.append("staff_id", item.emp_id);
      form.append("leave_id", item.id);
      axios
        .post(
          ServiceUrl.MOB.EMP_LEAVE_APPLY +
          "?" +
          jsonToQuery(getRandomuserParams(tableParams)),
          form
        )
        .then((res) => {
          getReport();
          Toast.show({
            content: "Leave Applied Successfully",
          });
        });
    } else {
      Toast.show({
        content: "Substitute Staff Approval Pending",
      });
    }
  };

  const handleCheck = (item) => {
    substituteStatus.filter;
    let res = substituteStatus.filter(
      (obj) =>
        obj.emp_leave_id == item.id && obj.leave_request_emp_id == item.emp_id
    );

    let leave = dataList.filter(
      (obj) => obj.id == item.id && obj.active_status == 2
    );

    const allActive = res.every((record) => record.substitute_status === "1");

    if (allActive) {
      return 1;
    } else if (leave.length > 0) {
      return 1;
    }
    return 0;
  };

  function parseQueryString(queryString) {
    // Split the query string into key-value pairs
    const pairs = queryString.split("&");
    const queryParams = {};

    // Iterate over each pair
    pairs.forEach((pair) => {
      const [key, value] = pair.split("=");
      queryParams[decodeURIComponent(key)] = decodeURIComponent(value);
    });

    return queryParams;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    const queryString = $("#frm_add").serialize();
    const queryParams = parseQueryString(queryString);

    let error = false;
    if (!queryParams.leave_type) error = true;
    else if (!queryParams.day) error = true;
    if (error) {
      Toast.show({
        content: "Please Select all the fields",
      });
      return;
    }

    // To find the staff has a classes or not (Code Started)
    const loadClasses = async () => {
      return new Promise((resolve, reject) => {
        let FRM = new FormData();
        let datesArray = getDatesBetween(fromDate, toDate);
        FRM.append("type", "today");
        FRM.append("date", momentDate(new Date(), "YYYY-MM-DD"));
        FRM.append("fromDate", fromDate);
        FRM.append("toDate", toDate);
        FRM.append("dayarray", datesArray);
        FRM.append("day", day);
        FRM.append("course", context.user.emp_academic_department);
        FRM.append("with_general", 0);

        setLoader(true);
        axios
          .post(ServiceUrl.MOB.TIME_TABLE_FOR_SUBSTITUTE, FRM)
          .then((res) => {
            if (res["data"].status == "1") {
              resolve(res["data"].data);
            } else {
              reject(res["data"].message || "Error");
            }
          });
      });
    };
    let classesFound = true;
    let result = await loadClasses();
    Object.values(result).forEach((item) => {
      if (Array.isArray(item) && item.length == 0) classesFound = false;
    });
    if (
      classesFound &&
      $("#request_staffs").val() == "[]" &&
      context.settingValue("substitute_staff_required") == 1
    ) {
      Toast.show({
        content: "Please Select substitute staff",
      });
      setLoader(false);
      return;
    }

    if (
      leaveTaken > 3 &&
      context.settingValue("longer_three_days_permission_required") == 1
    ) {
      Toast.show({
        content:
          "You are not authorized to apply for leave longer than three days; please get approval from the principal",
        duration: 6000,
      });
      setLoader(false);
      return;
    }

    if (
      context.settingValue("casual_leave_allowed_multiple") != 0 &&
      calculateExperience() <
      context.settingValue("casual_leave_allowed_multiple") &&
      leaveTaken > 1 &&
      upperCase(queryParams.leave_type).includes("CASUAL")
    ) {
      Toast.show({
        content:
          "You are allowed to take only one day of casual leave per month.When you apply for more than one day, it will automatically be considered as a Leave on Loss of Pay	(LLP).",
        duration: 9000,
      });
    }

    function getDatesBetween(from, to) {
      let start = new Date(from);
      let end = new Date(to);
      let dateArray = [];
      while (start <= end) {
        dateArray.push(start.toISOString().split("T")[0]);
        start.setDate(start.getDate() + 1);
      }
      return dateArray;
    }
    // To find the staff has a classes or not (Code Ended)

    setLoader(true);
    Toast.show("Processing...");
    const form = new FormData();
    form.append("staff_id", context.user.id);
    form.append("document_upload", selectedFile);

    axios
      .post(ServiceUrl.MOB.EMP_LEAVE_SAVE, $("#frm_add").serialize())
      .then((res) => {
        if (res["data"].status == "1") {
          Toast.show({ content: res["data"].message || "Saved" });
          setShowList(true);

          setShowForm(false);
          getReport();
          setLoader(false);
          document.getElementById("frm_add").reset();
        } else {
          Toast.show({ content: res["data"].message || "Error" });
          setLoader(false);
        }
      });
  };
  function handleApproval(type, item) {
    const form = new FormData();
    form.append("emp_id", item.emp_id);
    form.append("emp_name", item.emp_name);
    form.append("emp_code", item.emp_code);
    form.append("leave_from_date", item.from_date);
    form.append("leave_to_date", item.to_date);
    form.append("leave_id", item.id);
    form.append("leave_ids", item.leave_id);
    form.append("leave_type", item.leave_type);
    form.append("leave_count", item.leavecount);
    form.append("approved_by", context.user.id);
    form.append("totalcount", totalCount);
    form.append("approvalcount", item.approvalcount);
    form.append("department", context.user.emp_academic_department);

    if (type == "approved") {
      Dialog.confirm({
        title: "Do you want to approve ?",
        confirmText: "Yes",
        cancelText: "Cancel",
        onConfirm: () => {
          Toast.show("Processing...");
          form.append("approved_status", 1);
          axios.post(ServiceUrl.MOB.EMP_LEAVE_APPROVAL, form).then((res) => {
            if (res["data"].status == "1") {
              Toast.show({ content: res["data"].message || "Approved" });
              getReport();
            } else {
              Toast.show({ content: res["data"].message || "Error" });
            }
          });
        },
      });
    } else {
      Dialog.confirm({
        title: "Do you want to reject?",
        confirmText: "Yes",
        cancelText: "Cancel",
        content: (
          <Form.Control
            as="textarea"
            name="reason"
            id="reason"
            className="fw-bold mt-2"
            placeholder="Please enter reason"
            size="md"
            rows="3"
            required
          />
        ),
        onConfirm: () => {
          Toast.show("Processing...");
          form.append("approved_status", 0);
          form.append("reason", $("#reason").val());
          axios.post(ServiceUrl.MOB.EMP_LEAVE_APPROVAL, form).then((res) => {
            if (res["data"].status == "1") {
              Toast.show({ content: res["data"].message || "Rejected" });
              getReport();
            } else {
              Toast.show({ content: res["data"].message || "Error" });
            }
          });
        },
      });
    }
  }

  const approveSelectedLeaves = () => {
    const selected = employeeLeaves.filter((item) =>
      selectedLeaves.includes(item.id)
    );
    if (selected.length === 0) {
      Toast.show({ content: "No leave requests selected." });
      return;
    }

    const approvalPromises = selected.map((item) => {
      const form = new FormData();
      form.append("emp_id", item.emp_id);
      form.append("emp_name", item.emp_name);
      form.append("emp_code", item.emp_code);
      form.append("leave_from_date", item.from_date);
      form.append("leave_to_date", item.to_date);
      form.append("leave_id", item.id);
      form.append("leave_ids", item.leave_id);
      form.append("leave_type", item.leave_type);
      form.append("leave_count", item.leavecount);
      form.append("approved_by", context.user.id);
      form.append("totalcount", totalCount);
      form.append("approvalcount", item.approvalcount);
      form.append("department", context.user.emp_academic_department);
      form.append("approved_status", 1);

      return axios.post(ServiceUrl.MOB.EMP_LEAVE_APPROVAL, form);
    });

    Promise.all(approvalPromises)
      .then((results) => {
        const successCount = results.filter(
          (res) => res.data.status == "1"
        ).length;
        Toast.show({ content: `Successfully Approved` });

        getReport();
        setSelectedLeaves([]);
      })
      .catch((error) => {
        Toast.show({
          content: "An error occurred while processing approvals.",
        });
        console.error(error);
      });
  };

  function handleApprovalSubstitude(type, item) {
    const form = new FormData();
    form.append("id", item.id);
    // console.log(context);
    if (type == "approved") {
      Dialog.confirm({
        title: "Do you want to approve ?",
        confirmText: "Yes",
        cancelText: "Cancel",
        /*  content: (
          <Form.Control
            as="textarea"
            name="reason"
            id="reason"
            className="fw-bold mt-2"
            placeholder="Please enter reason"
            size="md"
            rows="3"
            required
          />
        ), */
        onConfirm: () => {
          Toast.show("Processing...");
          form.append("substitute_status", 1);
          axios
            .post(ServiceUrl.MOB.EMP_SUBSTITUTE_LEAVE_APPROVAL, form)
            .then((res) => {
              if (res["data"].status == "1") {
                Toast.show({ content: res["data"].message || "Approved" });
                getReport();
              } else {
                Toast.show({ content: res["data"].message || "Error" });
              }
            });
        },
      });
    } else {
      Dialog.confirm({
        title: "Do you want to reject?",
        confirmText: "Yes",
        cancelText: "Cancel",
        onConfirm: () => {
          Toast.show("Processing...");
          form.append("substitute_status", 2);
          //  form.append("reason", $("#reason").val());
          axios
            .post(ServiceUrl.MOB.EMP_SUBSTITUTE_LEAVE_APPROVAL, form)
            .then((res) => {
              if (res["data"].status == "1") {
                Toast.show({ content: res["data"].message || "Rejected" });
                getReport();
              } else {
                Toast.show({ content: res["data"].message || "Error" });
              }
            });
        },
      });
    }
  }

  const clearFile = () => {
    if (!window.confirm("Do you want to remove ?")) return;
    setSelectedFile("");
  };

  const getImage = () => {
    if (selectedFile && selectedFile.length > 0) return selectedFile;
    else if (oldFile && oldFile.length > 0) return getFileLiveUrl(oldFile);
    return SELECT_USER_PHOTO;
  };

  function handleChangeSubstitute(type, item) {
    setSubstituteEdit(item);
    handleView(item);
    setLeaveDate(item.from_date);
    setDayOrder(item.substitute_dayorder);
    setFromDate(item.from_date);
    setToDate(item.to_date);
    setLeaveDate(item.from_date);
    setEmpId(item.emp_id);
    setDay(item.day);
    setTakenLeaveCount(item.leavecount);
    setLeaveID(item.leave_id);
    setEmpLeaveID(item.id);
    setLeaveType(item.leave_type);
    setShowSubstituteHODEdit(true);
  }

  function handleHODApproval(type, item) {
    const form = new FormData();
    form.append("emp_id", item.emp_id);
    form.append("emp_name", item.emp_name);
    form.append("emp_code", item.emp_code);
    form.append("leave_from_date", item.from_date);
    form.append("leave_to_date", item.to_date);
    form.append("leave_id", item.id);
    form.append("leave_ids", item.leave_id);
    form.append("leave_type", item.leave_type);
    form.append("leave_count", item.leavecount);
    form.append("approved_by", context.user.id);
    form.append("totalcount", totalCount);
    form.append("approvalcount", item.approvalcount);
    form.append("department", context.user.emp_academic_department);

    Dialog.confirm({
      title: "Do you want to Endorse?",
      confirmText: "Yes",
      cancelText: "Cancel",
      content: (
        <Form.Control
          as="textarea"
          name="reason"
          id="reason"
          className="fw-bold mt-2"
          placeholder="Please enter reason"
          size="md"
          rows="3"
          required
        />
      ),
      onConfirm: () => {
        Toast.show("Processing...");
        form.append("approved_status", 3);
        form.append("reason", $("#reason").val());
        axios.post(ServiceUrl.MOB.EMP_LEAVE_APPROVAL, form).then((res) => {
          if (res["data"].status == "1") {
            Toast.show({ content: res["data"].message || "Rejected" });
            getReport();
          } else {
            Toast.show({ content: res["data"].message || "Error" });
          }
        });
      },
    });
  }

  const calculateDays = (e, leavect, fdate) => {
    setToDate(e);
    let startDay;
    if (fdate) startDay = new Date(fdate);
    else startDay = new Date(fromDate);

    const endDay = new Date(e);
    let count = 0;

    for (let d = startDay; d <= endDay; d.setDate(d.getDate() + 1)) {
      const currentDate = d.toISOString().split("T")[0];
      if (!holidays.some((holiday) => holiday.holiday_date === currentDate)) {
        count++;
      }
    }
    setLeaveTaken(count);
    if (day == "fullday") {
      if (leavect >= 0 && leavect != "") {
        setPendingCount(Math.max(0, leavect - count));
      } else {
        setPendingCount(Math.max(0, leaveCount - count));
      }
    } else {
      if (leavect >= 0) setPendingCount(Math.max(0, leavect - 0.5));
      else setPendingCount(Math.max(0, leaveCount - 0.5));
    }
  };

  const handleCheckboxChange = (itemId) => {
    setSelectedLeaves((prev) =>
      prev.includes(itemId)
        ? prev.filter((id) => id !== itemId)
        : [...prev, itemId]
    );
  };

  const handleCheckAll = (event) => {
    if (event.target.checked) {
      const allLeaveIds = employeeLeaves.map((item) => item.id);
      setSelectedLeaves(allLeaveIds);
    } else {
      setSelectedLeaves([]);
    }
  };

  const changeDay = (e) => {
    setDay(e);
    if (fromDate && toDate) {
      const startDay = new Date(fromDate);
      const endDay = new Date(e);
      let count = 1;

      for (let d = startDay; d <= endDay; d.setDate(d.getDate() + 1)) {
        const currentDate = d.toISOString().split("T")[0];
        if (!holidays.some((holiday) => holiday.holiday_date === currentDate)) {
          count++;
        }
      }

      if (e == "fullday") {
        setPendingCount(Math.max(0, leaveCount - count));
      } else {
        setPendingCount(Math.max(0, leaveCount - 0.5));
      }
    }
  };

  const handleDown = (index) => {
    $("#activestatus" + index).slideToggle(function () {
      if ($("#downarrow" + index).attr("src") == MOB_ICONS.DOWN_ARROW)
        $("#downarrow" + index).attr("src", MOB_ICONS.UP_ARROW);
      else $("#downarrow" + index).attr("src", MOB_ICONS.DOWN_ARROW);
    });
  };

  return (
    <>
      <Header title="Leave Request" backAction={true} rightActions={[]} />
      <div className="container leave">
        <Tabs
          className="bg-white"
          activeKey={activeTab}
          onChange={(k) => setActiveTab(k)}
        >
          <Tabs.Tab title={<>My Leaves</>} key="myleave" />
          {rolesAccess && (
            <Tabs.Tab
              title="Staff Leaves waiting for your approval"
              key="staffleave"
            />
          )}
          <Tabs.Tab title={<>Substitute Request</>} key="substitutestaff" />
        </Tabs>
      </div>
      <Spin spinning={loader}>
        {showList && activeTab == "myleave" && (
          <div>
            <div className="container">
              <Card className="mb-2">
                <Card.Header style={{ position: "relative" }}>
                  <h6>LEAVE </h6>
                  <FloatButton
                    icon={<img src={MOB_ICONS.ADD_BUTTON} />}
                    type="default"
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      position: "absolute",
                      top: "50%",
                      right: 24,
                      transform: "translateY(-50%)",
                      width: "32px",
                      height: "32px",
                    }}
                    onClick={() => {
                      setShowList(false);

                      setShowForm(true);
                    }}
                  />
                </Card.Header>
                <Card.Body className="fs-6">
                  <List>
                    {dataView.map((item, index) => (
                      <>
                        <List.Item
                          key={index + 1}
                          onClick={(e) => {
                            handleView(item);
                            setShowList(false);
                            setShowForm(false);
                            setShowListView(true);
                            setDay(item.day);
                          }}
                          prefix={
                            <Avatar
                              style={{
                                backgroundColor: "#f56a00",
                                verticalAlign: "middle",
                                textTransform: "uppercase",
                              }}
                              size="large"
                            >
                              {parseInt(item.approved) ? "A" : "W"}
                            </Avatar>
                          }
                          extra={
                            context.settingValue(
                              "substitute_approval_required"
                            ) == 1 ? (
                              handleCheck(item) == 0 ? (
                                <Button
                                  type="button"
                                  variant="danger"
                                  className="btn-sm btn-danger "
                                  onClick={(e) => {
                                    e.stopPropagation(); // to prevent triggering the onClick of List.Item
                                    handleButtonClick(item);
                                  }}
                                >
                                  Leave <br></br> Apply
                                </Button>
                              ) : (
                                ""
                              )
                            ) : (
                              ""
                            )
                          }
                        >
                          {item.leave_type} {/* */}
                          <Space size={[0, 8]} wrap>
                            {item.approved == "0" ? (
                              <Tag color="red">Rejected</Tag>
                            ) : item.approved == "1" ? (
                              <Tag color="green">Approved</Tag>
                            ) : (
                              <Tag color="orange">
                                {context.settingValue(
                                  "substitute_approval_required"
                                ) == 0
                                  ? item.approved == 2
                                    ? "Waiting for HOD approval"
                                    : "Waiting for Principal approval"
                                  : handleCheck(item) == 0
                                    ? "Waiting for staff approval"
                                    : item.approved == 2
                                      ? "Waiting for HOD approval"
                                      : "Waiting for Principal approval"}
                              </Tag>
                            )}
                          </Space>
                          <br />
                          <span style={{ fontSize: "13px" }}>
                            {momentDate(item.from_date, "DD/MM/YYYY")} to&nbsp;
                            {momentDate(item.to_date, "DD/MM/YYYY")}
                          </span>
                        </List.Item>
                      </>
                    ))}
                  </List>
                </Card.Body>
              </Card>
            </div>
          </div>
        )}

        {rolesAccess && activeTab == "staffleave" && (
          <div>
            <div className="container staff">
              <Card className="mb-2">
                <Card.Header
                  style={{
                    position: "relative",
                    background: " #fff",
                    paddingTop: "15px",
                  }}
                >
                  <h6>STAFF LEAVE APPROVAL </h6>
                </Card.Header>
                <Card.Body className="fs-6">
                  {upperCase(context.user.role_name).includes("PRINCIPAL") && (
                    <Button
                      variant="success"
                      size="sm"
                      onClick={approveSelectedLeaves}
                      style={{ float: "right" }}
                    >
                      Accept Selected
                    </Button>
                  )}

                  {upperCase(context.user.role_name).includes("PRINCIPAL") && (
                    <Form.Check
                      type="checkbox"
                      label={
                        <span style={{ fontSize: "14px", color: "#000" }}>
                          Check All
                        </span>
                      }
                      onChange={handleCheckAll}
                      checked={
                        selectedLeaves.length === employeeLeaves.length &&
                        employeeLeaves.length > 0
                      }
                    />
                  )}

                  <table>
                    <thead>
                      <tr>
                        {upperCase(context.user.role_name).includes(
                          "PRINCIPAL"
                        ) && <th scope="col">Select</th>}
                        <th scope="col">Name</th>
                        <th scope="col">Department</th>
                        <th scope="col">Period</th>
                        <th scope="col">Type</th>
                        <th scope="col">Approval</th>
                      </tr>
                    </thead>
                    <tbody>
                      {employeeLeaves &&
                        employeeLeaves.length > 0 &&
                        employeeLeaves.map((item) => (
                          <tr key={item.id}>
                            {upperCase(context.user.role_name).includes(
                              "PRINCIPAL"
                            ) && (
                                <td
                                  data-label="Select"
                                  style={{
                                    backgroundColor: selectedLeaves.includes(
                                      item.id
                                    )
                                      ? "#d4edda"
                                      : "transparent",
                                  }}
                                >
                                  <Form.Check
                                    type="checkbox"
                                    checked={selectedLeaves.includes(item.id)}
                                    onChange={() => handleCheckboxChange(item.id)}
                                  />
                                </td>
                              )}
                            <td data-label="Name">{item.emp_name}</td>
                            <td data-label="Department">
                              {item.academic_dept_name}
                            </td>
                            <td data-label="Period">
                              {" "}
                              {momentDate(item.from_date, "DD/MM/YYYY")} -{" "}
                              {momentDate(item.to_date, "DD/MM/YYYY")}
                            </td>
                            <td data-label="Type">{item.leave_type}</td>
                            <td data-label="Approval">
                              {item.approved_status != null ? (
                                item.approved == 1 ? (
                                  <>
                                    <img
                                      src={MOB_ICONS.APPROVED}
                                      style={{ width: "60%" }}
                                    />
                                  </>
                                ) : (
                                  <>
                                    {/*  <img
                                      src={MOB_ICONS.REJECTED}
                                      style={{ width: "60%" }}
                                    /> */}

                                    {/* <span
                                      style={{ color: "red", fontSize: "bold" }}
                                    >
                                      {item.reasons}
                                    </span> */}
                                  </>
                                )
                              ) : (
                                <>
                                  {item.approved_status == 2 && (
                                    <img
                                      src={MOB_ICONS.REJECTED}
                                      style={{ width: "60%" }}
                                    />
                                  )}
                                </>
                              )}
                              {upperCase(context.user.role_name).includes(
                                "PRINCIPAL"
                              ) &&
                                item.approved == 3 &&
                                (item.approved_status == null ||
                                  item.approved_status == 0) ? (
                                <>
                                  <a
                                    onClick={(e) =>
                                      handleApproval("approved", item)
                                    }
                                  >
                                    <img
                                      src={MOB_ICONS.ACCEPT_BUTTON}
                                      style={{ width: "60%" }}
                                    />
                                  </a>
                                  &nbsp;
                                  <a
                                    onClick={(e) =>
                                      handleApproval("rejected", item)
                                    }
                                  >
                                    <img
                                      src={MOB_ICONS.REJECT_BUTTON}
                                      style={{ width: "60%" }}
                                    />
                                  </a>{" "}
                                  <br />
                                </>
                              ) : (
                                ""
                              )}
                              {(upperCase(context.user.role_name).includes(
                                "HOD"
                              ) ||
                                upperCase(context.user.role_name).includes(
                                  "HEAD"
                                )) &&
                                item.approved == 2 &&
                                item.approved_status == null ? (
                                <>
                                  <a
                                    onClick={(e) =>
                                      handleHODApproval("approved", item)
                                    }
                                  >
                                    <Button
                                      type="button"
                                      variant="success"
                                      className="btn btn-block "
                                    >
                                      Endorse{" "}
                                    </Button>
                                  </a>
                                  <a
                                    onClick={(e) =>
                                      handleChangeSubstitute("approved", item)
                                    }
                                  >
                                    <Button
                                      type="button"
                                      variant="primary"
                                      className="btn btn-block "
                                      style={{ marginTop: "5px" }}
                                    >
                                      Change Substitute{" "}
                                    </Button>
                                  </a>
                                </>
                              ) : (
                                <span
                                  style={{ color: "red", fontSize: "bold" }}
                                >
                                  {item.reasons ? item.reasons : item.reason}
                                </span>
                              )}
                              {item.approved == 1 &&
                                item.approved_status == null && (
                                  <>
                                    <img
                                      src={MOB_ICONS.APPROVED}
                                      style={{ width: "60%" }}
                                    />
                                  </>
                                )}
                              {item.approved == 0 &&
                                item.approved_status == null && (
                                  <img
                                    src={MOB_ICONS.REJECTED}
                                    style={{ width: "60%" }}
                                  />
                                )}
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </Card.Body>
              </Card>
            </div>
          </div>
        )}

        {activeTab == "substitutestaff" && (
          <div>
            <div className="container staff">
              <Card className="mb-2">
                <Card.Header
                  style={{
                    position: "relative",
                    background: " #fff",
                    paddingTop: "15px",
                  }}
                >
                  <h6>SUBSTITUTE REQUEST APPROVAL </h6>
                </Card.Header>
                <Card.Body className="fs-6">
                  <table>
                    <thead>
                      <tr>
                        <th scope="col">Name</th>
                        <th scope="col">Subject</th>
                        <th scope="col">Hour</th>
                        <th scope="col">Day Order</th>
                        <th scope="col">Date</th>
                        <th scope="col">Approval</th>
                      </tr>
                    </thead>
                    <tbody>
                      {substituteLeaves &&
                        substituteLeaves.length > 0 &&
                        substituteLeaves.map((item) => (
                          <tr>
                            <td data-label="Name">{item.emp_name}</td>
                            <td data-label="Subject">
                              {item.substitute_subject_name}
                            </td>
                            <td data-label="Hour">{item.substitute_hour}</td>
                            <td data-label="Day Order">
                              {item.substitute_dayorder}
                            </td>
                            <td data-label="Date">
                              {" "}
                              {momentDate(
                                item.leave_request_date,
                                "DD/MM/YYYY"
                              )}
                            </td>
                            <td data-label="Approval">
                              {item.substitute_status != null &&
                                (item.substitute_status == 1 ? (
                                  <>
                                    <img
                                      src={MOB_ICONS.APPROVED}
                                      style={{ width: "60%" }}
                                    />
                                  </>
                                ) : (
                                  <>
                                    <img
                                      src={MOB_ICONS.REJECTED}
                                      style={{ width: "60%" }}
                                    />
                                  </>
                                ))}

                              {item.substitute_status == null ? (
                                <>
                                  <a
                                    onClick={(e) =>
                                      handleApprovalSubstitude("approved", item)
                                    }
                                  >
                                    <img
                                      src={MOB_ICONS.ACCEPT_BUTTON}
                                      style={{ width: "60%" }}
                                    />
                                  </a>
                                  &nbsp;
                                  <a
                                    onClick={(e) =>
                                      handleApprovalSubstitude("rejected", item)
                                    }
                                  >
                                    <img
                                      src={MOB_ICONS.REJECT_BUTTON}
                                      style={{ width: "60%" }}
                                    />
                                  </a>{" "}
                                  <br />
                                </>
                              ) : (
                                ""
                              )}
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </Card.Body>
              </Card>
            </div>
          </div>
        )}

        {showForm && (
          <div>
            <div className="container">
              <Card className="mb-2">
                <Card.Header style={{ position: "relative" }}>
                  <h6>ADD LEAVE </h6>
                  <FloatButton
                    icon={<img src={MOB_ICONS.CLOSE_BUTTON} />}
                    type="default"
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      position: "absolute",
                      top: "50%",
                      right: 24,
                      transform: "translateY(-50%)",
                      width: "32px",
                      height: "32px",
                    }}
                    onClick={() => {
                      setShowForm(false);
                      setShowList(true);
                    }}
                  />
                </Card.Header>
                <Card.Body>
                  <Form noValidate id="frm_add" onSubmit={handleSubmit}>
                    <input
                      type="hidden"
                      name="staff_id"
                      value={context.user.id}
                    />
                    <input
                      type="hidden"
                      name="experience"
                      value={calculateExperience()}
                    />
                    <input
                      type="hidden"
                      name="leave_taken"
                      value={leaveTaken}
                    />
                    <input
                      type="hidden"
                      name="emp_code"
                      value={context.user.emp_code}
                    />
                    <input
                      type="hidden"
                      name="emp_name"
                      value={context.user.emp_name}
                    />
                    <input type="hidden" name="approved" value={2} />
                    <input
                      type="hidden"
                      name="cl_limit_permonth"
                      value={context.settingValue(
                        "casual_leave_allowed_permonth"
                      )}
                    />
                    <input
                      type="hidden"
                      name="casual_leave_allowed_multiple"
                      value={context.settingValue(
                        "casual_leave_allowed_multiple"
                      )}
                    />
                    <input
                      type="hidden"
                      name="longer_three_days_permission_required"
                      value={context.settingValue(
                        "longer_three_days_permission_required"
                      )}
                    />
                    <input
                      type="hidden"
                      name="od_leave_attachment"
                      value={context.settingValue("od_leave_attachment")}
                    />
                    <input
                      type="hidden"
                      name="request_staffs"
                      id="request_staffs"
                      value={JSON.stringify(staffDetails)}
                    />

                    {selectedFile && (
                      <input
                        type="hidden"
                        name="document_upload"
                        value={selectedFile}
                      />
                    )}

                    <Row className="mt-2">
                      <Col md={3}>
                        <label className="fs-sm">
                          Leave Type <span className="text-danger">*</span>
                        </label>
                      </Col>
                      <Col md={7}>
                        <Form.Control
                          as="select"
                          className="fw-bold form-select form-select-sm"
                          size="sm"
                          name="leave_type"
                          id="leave_type"
                          onChange={(e) => onLeaveChange(e.target.value)}
                          required
                        >
                          <option value="">-Select-</option>
                          {leaveTypes.map((item) => (
                            <option value={item.leave_type}>
                              {item.leave_type}
                            </option>
                          ))}
                        </Form.Control>
                      </Col>
                    </Row>

                    <Row className="mt-2">
                      <Col md={3}>
                        <label className="fs-sm">
                          Day <span className="text-danger">*</span>
                        </label>
                      </Col>
                      <Col md={7}>
                        <Form.Control
                          as="select"
                          className="fw-bold form-select form-select-sm"
                          size="sm"
                          name="day"
                          onChange={(e) => changeDay(e.target.value)}
                          required
                        >
                          <option value="">-Select-</option>
                          <option value="fullday">Full Day</option>
                          <option value="morning">Forenoon</option>
                          <option value="afternoon">Afternoon</option>
                        </Form.Control>
                      </Col>
                    </Row>
                    <Row className="mt-2">
                      <Col md={3}>
                        <label className="fs-sm">
                          Available Leaves{" "}
                          <span className="text-danger">*</span>
                        </label>
                      </Col>
                      <Col md={7}>
                        <Form.Control
                          type="text"
                          className="fw-bold text-uppercase"
                          size="sm"
                          name="total_leaves"
                          value={leaveCount}
                        />
                      </Col>
                    </Row>
                    <Row className="mt-2">
                      <Col md={3}>
                        <Form.Label className="fs-sm">
                          From date <span className="text-danger">*</span>
                        </Form.Label>
                      </Col>
                      <Col md={5}>
                        <Form.Control
                          type="date"
                          className="fw-bold text-uppercase mt-2"
                          size="sm"
                          name="from_date"
                          onChange={(e) => {
                            setFromDate(e.target.value);
                            calculateDays(e.target.value, "", e.target.value);
                          }}
                          value={fromDate}
                          required
                        />
                      </Col>
                    </Row>

                    <Row className="mt-2">
                      <Col md={3}>
                        <label className="fs-sm">
                          To date <span className="text-danger">*</span>
                        </label>
                      </Col>

                      <Col md={5}>
                        <Form.Control
                          type="date"
                          className="fw-bold text-uppercase mt-2"
                          size="sm"
                          name="to_date"
                          min={fromDate}
                          onChange={(e) => calculateDays(e.target.value)}
                          value={toDate}
                          required
                        />
                      </Col>
                    </Row>

                    <Row className="mt-2">
                      <Col md={3}>
                        <label className="fs-sm">
                          Balance Leaves <span className="text-danger">*</span>
                        </label>
                      </Col>
                      <Col md={7}>
                        <Form.Control
                          type="text"
                          className="fw-bold text-uppercase"
                          size="sm"
                          name="pending_leave"
                          value={pendingCount}
                        />
                      </Col>
                    </Row>

                    <Row className="mt-2">
                      <Col md={3}>
                        <label className="fs-sm">Reason</label>
                      </Col>
                      <Col md={5}>
                        <Form.Control
                          as="textarea"
                          name="reason"
                          className="fw-bold mt-2"
                          size="md"
                          rows="3"
                        />
                      </Col>
                    </Row>

                    {context.settingValue("od_leave_attachment") == 1 && (

                      <Row>
                        <Col md={3}>
                          <label className="fs-sm">Document Upload</label>
                        </Col>
                        <Col md={5}>
                          <div
                            className="mt-2"
                            style={{
                              width: "180px",
                              marginLeft: "auto",
                              marginRight: "auto",
                            }}
                          >
                            <input
                              type="hidden"
                              name="document_upload"
                              value={selectedFile}
                            />
                            {selectedFile && (
                              <a
                                className="img-close-btn"
                                onClick={(e) => clearFile()}
                              >
                                x
                              </a>
                            )}
                            {selectedFile && (
                              <img
                                src={getImage()}
                                style={{
                                  width: "180px",
                                  cursor: "pointer",
                                  height: "190px",
                                }}
                              />
                            )}
                            <ReactFileReader
                              base64={true}
                              handleFiles={fileReaderChange}
                              fileTypes={[".jpg", ".png", ".JPG", ".PNG"]}
                            >
                              <Button size="sm" type="button" className="btn-block">
                                <i className="fa-solid fa-file-image me-2"></i>
                                {selectedFile ? "Change Image" : "Select Image"}
                              </Button>
                            </ReactFileReader>
                            {imageError && (
                              <div className="text-danger mt-2">
                                Please select an image.
                              </div>
                            )}
                          </div>
                        </Col>
                      </Row>
                    )}

                    <Row className="mt-2">
                      <Col md={3}></Col>
                      <Col md={5}>
                        <FloatButton
                          icon={<img src={MOB_ICONS.ADD_BUTTON} />}
                          type="default"
                          shape="square"
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            position: "absolute",
                            top: "43%",
                            right: 16,
                            transform: "translateY(-50%)",
                            width: "115px",
                            height: "33px",
                          }}
                          description="Add Substitute Staff"
                          onClick={(e) => setShowSubstitute(true)}
                        />{" "}
                      </Col>
                    </Row>
                    <Row>
                      <Col md={3}></Col>
                      <Col md={4} className="text-end">
                        <br />
                        <Button
                          type="submit"
                          variant="success"
                          className="btn btn-block "
                        >
                          Save
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                </Card.Body>
              </Card>
            </div>
          </div>
        )}
        {showListView && (
          <div>
            <div className="container ">
              <Card className="mb-2">
                <Card.Header style={{ position: "relative" }}>
                  <h6> VIEW LEAVE </h6>
                  <FloatButton
                    icon={<img src={MOB_ICONS.CLOSE_BUTTON} />}
                    type="default"
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      position: "absolute",
                      top: "50%",
                      right: 24,
                      transform: "translateY(-50%)",
                      width: "32px",
                      height: "32px",
                    }}
                    onClick={() => {
                      setShowListView(false);
                      setShowList(true);
                    }}
                  />
                </Card.Header>
                <Card.Body>
                  <div style={{ display: "" }}>
                    <div id="view">
                      <table
                        width="100%"
                        align="center"
                        className="font-bookman"
                        cellPadding={3}
                      >
                        <thead>
                          {context.settingValue("billheader_name") ? (
                            <>
                              {" "}
                              <tr align="center">
                                <th colSpan={3} align="center" height="30">
                                  <b>
                                    {context.settingValue("billheader_name")}
                                  </b>
                                </th>
                              </tr>
                            </>
                          ) : (
                            ""
                          )}
                        </thead>
                        <tbody>
                          <tr>
                            <td width="30%"> From Date</td>
                            <td align="center" width="10%">
                              :
                            </td>
                            <td>
                              {" "}
                              {momentDate(showView.from_date, "YYYY-MM-DD")}
                            </td>
                          </tr>
                          <tr>
                            <td width="30%"> To Date</td>
                            <td align="center" width="10%">
                              :
                            </td>
                            <td width="70%">
                              {" "}
                              {momentDate(showView.to_date, "YYYY-MM-DD")}
                            </td>
                          </tr>
                          <tr>
                            <td width="30%"> Leave Type</td>
                            <td align="center" width="10%">
                              :
                            </td>
                            <td width="70%"> {showView.leave_type}</td>
                          </tr>
                          <tr>
                            <td width="30%"> Day</td>
                            <td align="center" width="10%">
                              :
                            </td>
                            <td width="70%"> {showView.day}</td>
                          </tr>
                          <tr>
                            <td width="30%"> Reason</td>
                            <td align="center" width="10%">
                              :
                            </td>
                            <td width="70%"> {showView.reason}</td>
                          </tr>
                          <tr>
                            <td width="30%"> Leave Status</td>
                            <td align="center" width="10%">
                              :
                            </td>
                            <td width="70%">
                              {" "}
                              {showView.approved == 1 ? "Approved" : "Waiting"}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      {viewRequest && viewRequest.length > 0 && (
                        <>
                          <table
                            width="100%"
                            align="center"
                            className="font-bookman"
                            style={{
                              border: "1px solid #ccc",
                              fontSize: "14px",
                              paddingTop: "10px",
                            }}
                          >
                            <thead>
                              <tr align="center">
                                <th
                                  colSpan={3}
                                  align="center"
                                  height="30"
                                  style={{ backgroundColor: "#CCC" }}
                                >
                                  Substitute Staff Request Status
                                </th>
                              </tr>
                              <tr style={{ border: "1px solid #ccc" }}>
                                <th>Hours</th>
                                <th>Staff</th>
                                <th>Status</th>
                              </tr>
                            </thead>
                            <tbody>
                              {viewRequest &&
                                viewRequest.length > 0 &&
                                viewRequest.map((item, index) => (
                                  <>
                                    <tr>
                                      <td
                                        colSpan={3}
                                        style={{
                                          color: "blue",
                                          padding: "3px",
                                        }}
                                      >
                                        Request Date -{" "}
                                        {momentDate(
                                          item[index].leave_request_date,
                                          "DD/MM/YYYY"
                                        )}{" "}
                                        - Day Order:{" "}
                                        {item[index].substitute_dayorder}
                                        <div style={{ float: "right" }}>
                                          <Button
                                            type="button"
                                            variant="success"
                                            className="btn btn-block btn-sm"
                                            onClick={(e) => {
                                              setSubstituteEdit(item);
                                              setLeaveDate(
                                                item[index].leave_request_date
                                              );
                                              setDayOrder(
                                                item[index].substitute_dayorder
                                              );
                                              setShowSubstituteEdit(true);
                                            }}
                                          >
                                            Change Staff Details
                                          </Button>
                                        </div>
                                      </td>
                                    </tr>
                                    {item.map((record) => (
                                      <tr style={{ border: "1px solid #ccc" }}>
                                        <td width="20%" align="center">
                                          {record.substitute_hour}
                                        </td>
                                        <td width="50%">{record.emp_name}</td>
                                        <td
                                          width="20%"
                                          style={{
                                            color:
                                              record.substitute_status == 1
                                                ? "green"
                                                : record.substitute_status == 2
                                                  ? "red"
                                                  : "orange",
                                            fontWeight: "bold",
                                          }}
                                        >
                                          {record.substitute_status == 1
                                            ? "Approved"
                                            : record.substitute_status == 2
                                              ? "Rejected"
                                              : "Waiting"}
                                        </td>
                                      </tr>
                                    ))}
                                  </>
                                ))}
                            </tbody>
                          </table>
                        </>
                      )}
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </div>
          </div>
        )}
      </Spin>

      <Popup
        visible={showSubstitute}
        direction="vertical"
        position="top"
        bodyStyle={{ height: "80vh", overflowY: "scroll" }}
        showCloseButton={true}
        onMaskClick={() => {
          setShowSubstitute(false);
        }}
        onClose={() => {
          setShowSubstitute(false);
        }}
      >
        <div className="px-2 py-3">
          {" "}
          <LeaveSubstitute
            fromDate={fromDate}
            toDate={toDate}
            staff_id={context.user.id}
            day={day}
            onSuccess={(data) => {
              setStaffDetails(data);
              setShowSubstitute(false);
            }}
          />
        </div>
      </Popup>
      <Popup
        visible={showSubstituteEdit}
        direction="vertical"
        position="top"
        bodyStyle={{ height: "80vh", overflowY: "scroll" }}
        showCloseButton={true}
        onMaskClick={() => {
          setShowSubstituteEdit(false);
        }}
        onClose={() => {
          setShowSubstituteEdit(false);
        }}
      >
        <div className="px-2 py-3">
          {" "}
          <LeaveSubstituteEdit
            fromDate={fromDate}
            toDate={toDate}
            viewDate={substituteEdit}
            staff_id={context.user.id}
            leaveDate={leaveDate}
            dayOrder={dayOrder}
            day={day}
            onSuccess={(data) => {
              setStaffDetails(data);
              setShowSubstituteEdit(false);
            }}
          />
        </div>
      </Popup>
      <Popup
        visible={showSubstituteHODEdit}
        direction="vertical"
        position="top"
        bodyStyle={{ height: "80vh", overflowY: "scroll" }}
        showCloseButton={true}
        onMaskClick={() => {
          setShowSubstituteHODEdit(false);
        }}
        onClose={() => {
          setShowSubstituteHODEdit(false);
        }}
      >
        <div className="px-2 py-3">
          {" "}
          <LeaveSubstituteHODEdit
            fromDate={fromDate}
            toDate={toDate}
            viewDate={viewRequest}
            staff_id={empID}
            leaveDate={leaveDate}
            leave_id={leaveId}
            leaveEmpId={leaveEmpId}
            dayOrder={dayOrder}
            leaveTakenCount={leaveTakenCount}
            leaveType={leaveType}
            day={day}
            onSuccess={(data) => {
              setStaffDetails(data);
              getReport();
              setShowSubstituteHODEdit(false);
            }}
          />
        </div>
      </Popup>
    </>
  );
};
export default MyLeaveList2;
